import { FIELD_TYPES } from "constants/template-field-type";
import TestimonialConfig from "segments/desktop/core-components/testimonial/fields-config";
import VerticalTimerTabsConfig from "segments/desktop/core-components/vertical-timer-tabs/fields-config";
import FullWithBulletsParagraphConfig from "segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config";
import AssetFieldsConfig from "components/core/asset/fields-config";
import TitleConfig from "segments/desktop/core-components/title/fields-config";
import ThemeConfig from "segments/core-configs/theme-config";

const {
  timerEnabled,
  buttonConfig,
  showButton,
  progressbarColor,
  backgroundColor,
  tabs: {
    nestedConfig: {
      fields: { timer, ...nestedTabsConfig }
    },
    ...tabsConfig
  },
  ...rest
} = VerticalTimerTabsConfig;

const { textAlign, mobileTextAlign, title, titleColor, textColor, bodyColor, topic, ...restOfParagraphConfig } =
  FullWithBulletsParagraphConfig.fields;

export default {
  type: FIELD_TYPES.NESTED,
  fields: {
    ...ThemeConfig,
    tabsTitle: {
      type: FIELD_TYPES.NESTED,
      label: "Title",
      fields: TitleConfig
    },
    tabs: {
      type: FIELD_TYPES.MULTIPLE_NESTED,
      label: "Tabs",
      nestedConfig: {
        type: FIELD_TYPES.NESTED,
        fields: {
          title: { type: FIELD_TYPES.TEXT, label: "Tab Title", translatable: true },
          overrideTabFontColor: { type: FIELD_TYPES.COLOR_PICKER, label: "Title Font Color" },
          content: {
            type: FIELD_TYPES.NESTED,
            label: "Tab Content",
            fields: { ...restOfParagraphConfig }
          },
          testimonial: TestimonialConfig,
          asset: {
            type: FIELD_TYPES.NESTED,
            label: "Asset",
            fields: AssetFieldsConfig
          }
        },
        ...nestedTabsConfig
      },
      ...tabsConfig
    },
    ...rest
  }
};
